<template>
    <div v-if="mobile" class="box">
        <div class="phone_img_box">
            <img class="phone_img" :src="$OSSBaseUrl+'phone.png'">
        </div>
        <div class="phone_num">
            绑定手机号：<span>{{mobile}}</span>
        </div>
        <div class="button_box">
            <router-link :to="{path:'BuildPhone',query:{title:'更换绑定手机号',page_from:'change_mobile'}}">
                <div class="button">更换手机号</div>
            </router-link>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { mapState } from 'vuex';

export default {
    name:'ShowPhone',
    data(){
        return{
            mobile:'',
        }
    },
    mounted() {
        if(this.$route.query.id){
            sessionStorage.setItem('Phone_Account_ID',this.$route.query.id)
            this.$store.dispatch('ShowPhone/GetReceiverById',{receiver_id:this.$route.query.id}).then(res=>{
                if(res.code==1000){
                    this.mobile = res.data.mobile
                }else{
                    Toast(res.message)
                }
            })
        }else{
            this.mobile = this.$route.query.mobile
        }
    },
    computed:{
        ...mapState({
            getAccountBindList: (state)=>{
                return state.BuildAccount.GetAccountBindList
            }
        })
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>